<template>
  <v-card elevation="3" outlined class="mb-4">
    <v-card-title class="mycard-title-1 fsize-4 fcolor-1 bg-color-2">
      <v-icon class="mr-2" color="white">mdi-office-building</v-icon>
      Organization Details
    </v-card-title>
    <v-card-text>
      <v-container>
        <!-- LOM Basic Information -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-domain</v-icon>
                LO Name
              </div>
              <div class="info-value">{{ lomInfo.LomName }}</div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-map</v-icon>
                Zone Name
              </div>
              <div class="info-value">{{ lomInfo.ZoneName }}</div>
            </div>
          </v-col>

          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-calendar-plus</v-icon>
                Affiliation Date
              </div>
              <div class="info-value">{{ lomInfo.AffiliationDateTxt }}</div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-check-circle</v-icon>
                LO Status
              </div>
              <div class="info-value">
                <v-chip small :color="lomInfo.LomStatusColor" dark>
                  {{ lomInfo.LomStatusTxt }}
                </v-chip>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-city</v-icon>
                City
              </div>
              <div class="info-value">{{ lomInfo.LomCity }}</div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-map-marker-radius</v-icon>
                District
              </div>
              <div class="info-value">{{ lomInfo.LomDistrict }}</div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-map-marker</v-icon>
                State
              </div>
              <div class="info-value">{{ lomInfo.LomState }}</div>
            </div>
          </v-col>

          <v-col cols="12" md="3">
            <div class="info-item">
              <div class="info-label">
                <v-icon small class="mr-1">mdi-vote</v-icon>
                Voting Count
              </div>
              <div class="info-value">
                <v-chip small color="success" dark>
                  {{ lomInfo.VotingCount }}
                </v-chip>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- LOM Growth Chart -->
        <v-row v-if="lomGrowthData && lomGrowthData.length > 0" class="mt-4">
          <v-col cols="12">
            <div class="subsection-title">
              <v-icon small class="mr-1">mdi-chart-line</v-icon>
              LO Growth History
            </div>
            <v-data-table
              :headers="lomGrowthHeader"
              :items="lomGrowthData"
              hide-default-footer
              disable-sort
              class="elevation-1 mt-2"
              :items-per-page="-1"
            >
              <template v-slot:[`item.YearName`]="{ item }">
                <v-chip small color="primary" dark>{{ item.YearName }}</v-chip>
              </template>
              <template v-slot:[`item.Growth`]="{ item }">
                <v-chip small :color="item.Color" dark>
                  {{ item.Growth }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- Payment Information -->
        <v-row
          v-if="paymentInfo && Object.keys(paymentInfo).length > 0 && paymentInfo.NominationPaymentId"
          class="mt-4"
        >
          <v-col cols="12">
            <div class="subsection-title">
              <v-icon small class="mr-1">mdi-credit-card</v-icon>
              Payment Information
            </div>
            <v-card outlined class="mt-2">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <div class="info-item">
                      <div class="info-label">Payment ID</div>
                      <div class="info-value">{{ paymentInfo.PaymentRzrpayId }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="info-item">
                      <div class="info-label">Payment Date</div>
                      <div class="info-value">
                        {{ paymentInfo.PaymentDate }}
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="info-item">
                      <div class="info-label">Amount</div>
                      <div class="info-value">
                        {{ paymentInfo.PaymentAmount }}
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="info-item">
                      <div class="info-label">Payment Method</div>
                      <div class="info-value">
                        {{ paymentInfo.PaymentMethod }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "OrganizationDetailsCard",
  props: {
    lomInfo: {
      type: Object,
      default: () => ({
        LomName: "",
        ZoneName: "",
        AffiliationDate: "",
        LomCity: "",
        LomDistrict: "",
        LomState: "",
        LomStatus: "",
        VotingCount: 0,
      }),
    },
    lomGrowthHeader: {
      type: Array,
      default: () => [
        { text: "Year", value: "YearName" },
        { text: "Count", value: "Count" },
      ],
    },
    lomGrowthData: {
      type: Array,
      default: () => [],
    },
    paymentInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getStatusColor(status) {
      switch (status?.toLowerCase()) {
        case "active":
          return "success";
        case "inactive":
          return "error";
        case "suspended":
          return "warning";
        default:
          return "grey";
      }
    },
    getPaymentStatusColor(status) {
      switch (status?.toLowerCase()) {
        case "completed":
        case "success":
          return "success";
        case "failed":
        case "error":
          return "error";
        case "pending":
          return "warning";
        default:
          return "grey";
      }
    },
    getProgressPercentage(count) {
      // Calculate percentage based on max value in the data
      if (!this.lomGrowthData || this.lomGrowthData.length === 0) return 0;
      const maxCount = Math.max(
        ...this.lomGrowthData.map((item) => item.Count)
      );
      return maxCount > 0 ? (count / maxCount) * 100 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-item {
  margin-bottom: 16px;

  .info-label {
    font-size: 12px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
  }

  .info-value {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    word-break: break-word;
  }
}

.subsection-title {
  font-size: 16px;
  font-weight: 600;
  color: #0097d7;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.mycard-title-1 {
  font-family: sans-serif;
  padding: 16px;
  text-align: left;
  word-break: break-word;
  line-height: normal;
}

.fsize-4 {
  font-size: 18px !important;
}

.fcolor-1 {
  color: #fff !important;
}

.bg-color-2 {
  background-color: #0097d7;
}
</style>
